module.exports = __webpack_public_path__ + "img/img_10.c728c226.webp";